// extracted by mini-css-extract-plugin
export default {"title":"_b2be5a72","copy":"_f2992477","searchTerm":"_f808feb2","shimmer":"_9b059d97","shimmerLoadingBackground":"_a57e01ff"};